import styles from './time-picker.module.scss';
import { TimePicker as MaterialTimePicker } from '@mui/x-date-pickers/TimePicker';
import { StaticTimePicker as MaterialStaticTimePicker } from '@mui/x-date-pickers/StaticTimePicker';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import nb from "date-fns/locale/nb";

/* eslint-disable-next-line */
export interface TimePickerProps {
  onChange: (event: any) => void,
  renderInput: any,
  // acceptRegex?: any,
  // ampm?: boolean,
  // ampmInClock?: boolean,
  // cancelText?: ReactNode,
  // className?: string,
  // clearable?: boolean,
  // clearText?: ReactNode,
  // components?: any,
  // desktopModeMediaQuery?: string,
  // DialogProps?: object,
  // disableCloseOnSelect?: boolean,
  // disabled?: boolean,
  // disableIgnoringDatePartForTimeValidation?: boolean,
  // disableMaskedInput?: boolean,
  // disableOpenPicker?: boolean,
  // getClockLabelText?: any,
  // getOpenDialogAriaText?: any,
  // InputAdornmentProps?: object,
  inputFormat?: string,
  // inputRef?: any,
  mask?: string,
  // maxTime?: any,
  // minTime?: any,
  // minutesStep?: number,
  // okText?: ReactNode,
  // onAccept?: () => void,
  // onClose?: () => void,
  // onError?: () => void,
  // onOpen?: () => void,
  // onViewChange?: () => void,
  open?: boolean,
  // OpenPickerButtonProps?: object,
  // openTo?: 'hours' | 'minutes' | 'seconds',
  // orientation?: 'landscape' | 'portrait',
  // PaperProps?: object,
  // PopperProps?: object,
  // readOnly?: boolean,
  // rifmFormatter?: () => void,
  // shouldDisableTime?: () => void,
  // showTodayButton?: boolean,
  // showToolbar?: boolean,
  // todayText?: ReactNode,
  // ToolbarComponent?: any,
  // toolbarFormat?: string,
  // toolbarPlaceholder?: ReactNode,
  // toolbarTitle?: ReactNode,
  // TransitionComponent?: any,
  value?: any | Date | number | string,
  // views?: Array<'hours' | 'minutes' | 'seconds'>,
  label?: string
}

export interface StaticTimePickerProps {
  onChange: (event: any) => void,
  renderInput: any,
  // acceptRegex?: any,
  // ampm?: boolean,
  // ampmInClock?: boolean,
  // className?: string,
  // components?: any,
  // disableCloseOnSelect?: boolean,
  // disabled?: boolean,
  // disableIgnoringDatePartForTimeValidation?: boolean,
  // disableMaskedInput?: boolean,
  // disableOpenPicker?: boolean,
  displayStaticWrapperAs?: 'desktop' | 'mobile',
  // getClockLabelText?: any,
  // getOpenDialogAriaText?: any,
  // InputAdornmentProps?: object,
  // inputFormat?: string,
  // inputRef?: any,
  // mask?: string,
  // maxTime?: any,
  // minTime?: any,
  // minutesStep?: number,
  // onAccept?: () => void,
  // onClose?: () => void,
  // onError?: () => void,
  // onOpen?: () => void,
  // onViewChange?: () => void,
  // open?: boolean,
  // OpenPickerButtonProps?: object,
  // openTo?: 'hours' | 'minutes' | 'seconds',
  // orientation?: 'landscape' | 'portrait',
  // readOnly?: boolean,
  // rifmFormatter?: () => void,
  // shouldDisableTime?: () => void,
  // showToolbar?: boolean,
  // ToolbarComponent?: any,
  // toolbarFormat?: string,
  // toolbarPlaceholder?: ReactNode,
  // toolbarTitle?: ReactNode,
  value?: any | Date | number | string,
  // views?: Array<'hours' | 'minutes' | 'seconds'>
}

export function TimePicker(props: TimePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={nb}>
      <MaterialTimePicker
        value={props.value}
        onChange={props.onChange}
        renderInput={props.renderInput}
        inputFormat={props.inputFormat}
        mask={props.mask}
        label={props.label}
        open={props.open}
      />
    </LocalizationProvider>
  );
}

export function StaticTimePicker(props: StaticTimePickerProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={nb}>
      <MaterialStaticTimePicker
        displayStaticWrapperAs={props.displayStaticWrapperAs}
        value={props.value}
        onChange={props.onChange}
        renderInput={props.renderInput}
      />
    </LocalizationProvider>
  );
}

export default TimePicker;